<template>
	<div style="background-color: #fdfdfd;">
		<Header :isHome="false"></Header>

		<div v-if="data">
			<div style="height: auto;overflow: hidden;position: relative;">
				<div class="top-bg" :style="{backgroundImage:'url('+data.coverImage+')'}" style="margin: -2rem;"></div>
				<div class="title-box container" style="padding-top: 7rem;">
					<div :style="{backgroundImage:'url('+data.logo+')'}" style="" class="title-img"></div>
					<div style="display: flex;flex-direction: column;width: 100%;">
						<div style="" class="title">{{data.providerName}}</div>
						<div style="margin-top: 0.5rem;">
							<div style="display: flex;flex-wrap: wrap">
								<div v-for="(c, index) in data.certifications" :key="index" style="padding:0rem 0.5rem;border: 1px solid #000;border-radius: 2rem;font-size: 0.6rem;
								display: flex;align-items: center;justify-content: center;margin-right: 0.5rem;margin-bottom: 0.5rem;">
									{{c.name}}
								</div>
							</div>
						</div>
						<div style="" v-if="data.website">For more company content,
							<span style="text-decoration: underline;color: #00E8BE;cursor: pointer;"
								@click="toaddr()">enter the website</span>
						</div>

						<div style="display: flex;margin-top: 1rem;justify-content: space-between;">
							<!-- <div style="background-color: #31ffda;color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
									font-weight: bold;width: 6rem;">FOLLOW</div> -->
							<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
										font-weight: bold;width: 6rem;cursor: pointer;"
								:class="{'btn-cyan':!data.follow, 'btn-lightgreen':data.follow}"
								@click="changefollow(data)" v-text="data.follow?'UnFollow':'Follow'"></div>

							<!-- <div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
										font-weight: bold;width: 6rem;cursor: pointer;" class="btn-normal" @click="toEdit" v-if="providerinfo">Edit</div> -->

							<div v-if="providerinfo">
								<!-- 供应商审核中按钮 -->
								<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
											font-weight: bold;width: fit-content;" @click="reviewing" class="btn-normal" v-if="providerinfo.status==3">
									<img src="../../assets/imgs/reviewing.svg"
										style="width: 1rem;height: 1rem;margin-right: 0.5rem;">under review...
								</div>

								<!-- 供应商跳转编辑页成功 -->
								<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
											font-weight: bold;width: 6rem;cursor: pointer;" class="btn-normal" @click="toEdit"
									v-if="providerinfo.status==1">Edit</div>

								<!-- 供应商跳转编辑页失败 -->
								<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
											font-weight: bold;width: fit-content;;cursor: pointer;" class="btn-normal" @click="toEdit"
									v-if="providerinfo.status==2">
									<img src="../../assets/imgs/message-info.svg"
										style="width: 1rem;height: 1rem;margin-right: 0.5rem;">Review failed and re edit
								</div>

								<!-- 供应商冻结按钮 -->
								<div style="color: #ff1c1c;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
											font-weight: bold;width: fit-content;" @click="locking" class="btn-normal" v-if="providerinfo.status==4">
									<img src="../../assets/imgs/locking.png"
										style="width: 1rem;height: 1rem;margin-right: 0.5rem;">frozen
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container" style="padding-bottom: 3rem;">
				<div style="font-size: 1rem;font-weight: 500;margin-top: 1rem;cursor: pointer;"><span
						@click="tosupplierlist()" class="line-title">Service Providers</span> > Company Profile</div>
				<div class="df tabs" style="margin-top: 2rem;">
					<div class="r-title por hover-light" style="margin-right: 2rem;cursor: pointer;"
						@click="changeList(index)" :style="{color:activeIndex==index?'#00E8BE':'#000'}"
						v-for="(item,index) in isPay?(showTabs?['Company Profile','Product','My Quotation','Users Inquire']:['Company Profile','Product']):['Company Profile',]"
						:key="index">
						<!-- <img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg"> -->
						<span style="z-index: 1;white-space: nowrap;">{{item}}</span>
					</div>
				</div>
				<template v-if="activeIndex==0">
					<div style="border: 1px solid #DDD7D7;border-radius: 0.5rem;padding: 1rem;margin-bottom: 1rem;user-select: none;"
						ref="el" v-html="data.profile"></div>

					<div class="r-title" style="margin-top: 2rem;" v-show="data.credentials.length>0">
						<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
						<span style="z-index: 1;position: relative;">Qualification</span>
					</div>
					<div style="display: flex;align-items: center;flex-wrap: wrap;border: 1px solid #DDD7D7;padding: 1rem;margin-bottom:3rem;border-radius: 0.5rem;"
						v-show="data.credentials.length>0">
						<div v-for="(img, qindex) in data.credentials" :key="qindex">
							<div :style="{backgroundImage:'url('+img+')'}" style="width: 9rem;height: 9rem;margin-right: 1rem;margin-bottom: 1rem;background-position: center;
									background-repeat: no-repeat;background-size: contain;cursor: pointer;"
								@click="largeimg(data.credentials, qindex)"></div>
						</div>
					</div>
				</template>
				<div class="main-box df jcsa fww" style="flex: 1;" v-if="activeIndex==1&&isMobile">
					<div v-if="showTabs" class="supplier-box addproduct" style="width: 48%;" @click="addProduct"
						:style="{width:isMobile?'50%':'15rem','height':isMobile?'10rem':'15rem'}">
						<div class="df fdc aic jcc hover-up transition-normal"
							style="margin: 0 1rem;width: 100%;height: 100%;border:0.05rem solid rgba(0, 0, 0, 0.1);font-weight: bold;">
							<i class="el-icon-circle-plus-outline" style="font-size: 3rem;color: #CECECE;"></i>
							<div style="" class="main-title" v-text="'Add product'"></div>
						</div>
					</div>
					<div class="supplier-box" style="width: 48%;" v-for="(item, index2) in list" :key="index2"
						@click="$router.push({name: 'productDetail',query:{id:item.id}})">
						<div v-if="item.main_pics"
							:style="{backgroundImage: `url(${item.main_pics[0]})`,width:isMobile?'10rem':'15rem','min-height':isMobile?'10rem':'15rem'}"
							style="" class="hover-up main-img transition-normal por">
							<template v-if="showTabs">
								<el-button @click.stop="update(item)" v-if="item.status==2"
									style="background-color: #000;color: #fff;right: 10px;top: 10px;" size="mini"
									class="poa">Edit</el-button>
								<el-button v-if="item.status==1" @click.stop="getList()" style="right: 10px;top: 10px;"
									size="mini" class="poa">Review...</el-button>
								<el-button v-if="item.status==3" type="danger" @click.stop="update(item)"
									style="right: 10px;top: 10px;" size="mini" class="poa">Review failed,
									re-edit</el-button>
								<template v-if="item.status==2">
									<el-button @click.stop="changeStatus(item)" v-if="item.state" type='danger'
										style="right: 10px;top: 50px;" size="mini" class="poa">unactive</el-button>
									<el-button @click.stop="changeStatus(item)" v-else type='success'
										style="right: 10px;top: 50px;" size="mini" class="poa">active</el-button>
								</template>
							</template>
						</div>
						<div style="font-weight: bold;margin-top: 1rem;" class="main-title text_over_2line"
							:style="isMobile?'font-size: 16px;':'font-size: 20px;'" v-text="item.title"></div>
					</div>
					<div v-if="list.length%2==0" class="supplier-box addproduct" style="width: 48%;opacity: 0;"
						:style="{width:isMobile?'50%':'15rem','height':isMobile?'10rem':'15rem'}">
					</div>
					<div v-show="list.length==0&&!showTabs" class="nodata-box col-12">
						<img src="../../assets/imgs/nodata.svg" class="nodata-img">
					</div>
				</div>
				<div class="main-box row" style="flex: 1;" v-if="activeIndex==1&&!isMobile">
					<div v-if="showTabs" class="supplier-box addproduct col-3" @click="addProduct"
						:style="{width:isMobile?'50%':'15rem','height':isMobile?'10rem':'15rem'}">
						<div class="df fdc aic jcc hover-up transition-normal"
							style="margin: 0 1rem;width: 100%;height: 100%;border:0.05rem solid rgba(0, 0, 0, 0.1);font-weight: bold;">
							<i class="el-icon-circle-plus-outline" style="font-size: 3rem;color: #CECECE;"></i>
							<div style="" class="main-title" v-text="'Add product'"></div>
						</div>
					</div>
					<div class="supplier-box col-3" v-for="(item, index2) in list" :key="index2"
						@click="$router.push({name: 'productDetail',query:{id:item.id}})">
						<div v-if="item.main_pics"
							:style="{backgroundImage: `url(${item.main_pics[0]})`,width:isMobile?'10rem':'15rem','min-height':isMobile?'10rem':'15rem'}"
							style="" class="hover-up main-img transition-normal por">
							<template v-if="showTabs">
								<el-button @click.stop="update(item)" v-if="item.status==2"
									style="background-color: #000;color: #fff;right: 10px;top: 10px;" size="mini"
									class="poa">Edit</el-button>
								<el-button v-if="item.status==1" @click.stop="getList()" style="right: 10px;top: 10px;"
									size="mini" class="poa">Review...</el-button>
								<el-button v-if="item.status==3" type="danger" @click.stop="update(item)"
									style="right: 10px;top: 10px;" size="mini" class="poa">Review failed,
									re-edit</el-button>
								<template v-if="item.status==2">
									<el-button @click.stop="changeStatus(item)" v-if="item.state" type='danger'
										style="right: 10px;top: 50px;" size="mini" class="poa">unactive</el-button>
									<el-button @click.stop="changeStatus(item)" v-else type='success'
										style="right: 10px;top: 50px;" size="mini" class="poa">active</el-button>
								</template>
							</template>
						</div>
						<div style="font-weight: bold;margin-top: 1rem;" class="main-title text_over_2line"
							:style="isMobile?'font-size: 16px;':'font-size: 20px;'" v-text="item.title"></div>
					</div>
					<div v-show="list.length==0&&!showTabs" class="nodata-box col-12">
						<img src="../../assets/imgs/nodata.svg" class="nodata-img">
					</div>
				</div>
				<el-dialog @close="active=0" title="Add product" :visible.sync="dialogVisible"
					:width="isMobile?'90%':'50%'" center>
					<el-steps align-center :active="active" finish-status="success">
						<el-step title="Basic Information"></el-step>
						<el-step title="Product Properties"></el-step>
						<el-step title="Detailed introduction"></el-step>
					</el-steps>
					<template v-if="active==0">
						<div style="margin-top: 2rem;">
							<div class="label df aic">
								<span class="require">*</span>
								<span>type</span>
							</div>
							<!-- <el-select @change="selectType" style="width: 100%;" v-model="formParams.categoryId" clearable
								placeholder="Choose type">
								<el-option v-for="(item,index) in categories" :key="index" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select> -->
							<el-cascader style="width: 100%;" :options="categories"
								:props="{ expandTrigger: 'hover',value:'id',label:'name', checkStrictly: true  }"
								@change="handleChange"></el-cascader>
						</div>
						<div style="margin-top: 2rem;">
							<div class="label df aic">
								<!-- <span class="require">*</span> -->
								<span>brand</span>
							</div>
							<div class="df">
								<el-select style="width: 100%;" v-model="formParams.brandId" clearable
									placeholder="Choose  brand">
									<el-option v-for="(item,index) in brands" :key="item.name" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
						</div>
						<div style="margin-top: 2rem;">
							<div class="label df aic">
								<span class="require">*</span>
								<span>Origin</span>
							</div>
							<div class="df">
								<el-select style="width: 100%;" v-model="formParams.countryId" clearable
									placeholder="Choose  Origin">
									<el-option v-for="(item,index) in countrys" :key="index" :label="item.englishName"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
						</div>
						<div style="margin-top: 2rem;">
							<div class="label">Certification</div>
							<div class="df">
								<el-select style="width: 100%;" v-model="formParams.certification" clearable
									placeholder="Choose  Certification">
									<el-option v-for="(item,index) in authentications" :key="index" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
						</div>
						<div style="margin-top: 2rem;">
							<div class="label df aic">
								<span class="require">*</span>
								<span>Requirement title</span>
							</div>
							<el-input v-model="formParams.title" placeholder="Enter title"></el-input>
						</div>
						<div style="margin-top: 2rem;">
							<div class="label df aic">
								<span class="require">*</span>
								<span>Requirements introduction</span>
							</div>
							<el-input type="textarea" :rows="4" placeholder="Enter content"
								v-model="formParams.sub_title">
							</el-input>
						</div>
					</template>
					<template v-else-if="active==1">
						<div v-if="showProperties" style="margin-top: 2rem;" v-for="(item,index) in propertiesList"
							:key="item.id">
							<div class="label">{{item.label}}</div>
							<div class="df">
								<el-select style="width: 100%;" @change="change($event,item.label)"
									:value="properties[item.label]" clearable placeholder="Choose properties">
									<el-option v-for="(item2,index2) in item.property_values" :key="item2.value"
										:label="item2.value" :value="item2.id">
									</el-option>
								</el-select>
							</div>
						</div>
					</template>
					<template v-else-if="active==2">
						<div class="label df aic">
							<span class="require">*</span>
							<span>Main picture</span>
						</div>
						<el-upload multiple style="margin-bottom: 1rem;" :limit="6"
							action="https://gci.oointer.com/upload" list-type="picture-card"
							:on-preview="handlePictureCardPreview" :on-remove="remove" :on-success="upload"
							:file-list="fileList">
							<i class="el-icon-plus"></i>
						</el-upload>
						<vue-editor useCustomImageHandler @image-added="handleImageAdded"
							v-model="formParams.description" ref="editor"></vue-editor>
					</template>
					<div class="df jcc" style="margin-top: 2rem;" v-if="active!=3">
						<el-button type="info" style="margin-right: 0.5rem;" v-if="active!=0"
							@click="previous">Previous</el-button>
						<el-button v-if="active!=2" style="width: 100px;" @click="next">Next</el-button>
						<el-button v-else style="width: 100px;background-color: #22F7D3;"
							@click="submit">Submit</el-button>
					</div>
				</el-dialog>
				<div class="df fdc" v-if="activeIndex==2">
					<div class="items hover-up transition-normal fadeIn" v-for="(item, index2) in list" :key="index2"
						@click="$router.push({name: 'demandDetails',query:{id:item.productCustomId}})">
						<div class="df aic" v-if="item.user">
							<img class="avatar" :src="item.user.actar" alt="" />
							<div class="user-name" v-text="item.user.username"></div>
						</div>
						<div v-if="item.productCustom" class="title">{{item.productCustom.title}}</div>
						<div v-if="item.productCustom" class="subTitle text_over_2line">{{item.productCustom.sub_title}}
						</div>
						<div class="df jcsb"
							style="font-weight: bold;border-top: 1px solid #DEDEDE;padding-top: 1rem;margin-top: 1rem;">
							<div class="df">
								<span>Quotation：</span>
								<span style="color: #FF0000;">${{item.offer_price}}</span>
							</div>
							<span>See Inquire</span>
						</div>
					</div>
					<div v-show="list.length==0" class="nodata-box">
						<img src="../../assets/imgs/nodata.svg" class="nodata-img">
					</div>
				</div>
				<div class="df fdc" v-if="activeIndex==3">
					<div class="items hover-up transition-normal fadeIn" v-for="(item, index2) in list" :key="index2"
						@click="detail(item)">
						<div class="df jcsb">
							<div class="df aic" v-if="item.user">
								<img class="avatar" style="width: 30px;height: 30px;" :src="item.user.avatar" alt="" />
								<div class="user-name" v-text="item.user.username"></div>
							</div>
							<div>{{item.createdAt|format}}</div>
						</div>
						<div class="df text_over">
							<div class="df aic" style="margin-right: 1rem;">
								<div class="value">Name: </div>
								<div class="label">{{item.name}}</div>
							</div>
							<div class="df aic" style="margin-right: 1rem;">
								<div class="value">Contact: </div>
								<div class="label">{{item.contact}}</div>
							</div>
							<div class="df aic">
								<div class="value">service: </div>
								<a style="color:#2284E6;text-decoration: underline;" class="label"
									v-if="item.provider">{{item.provider.providerName}}</a style="color:#2284E6;">
							</div>
						</div>
						<div class="subTitle text_over_2line">{{item.content}}</div>
						<div class="df aic" v-if="item.product||item.productCustom"
							style="font-weight: bold;border: 1px solid #DEDEDE;padding: 1rem;margin-top: 1rem;background-color: #FAFAFA;">
							<img v-if="item.product" :src="item.product.main_pics[0]" width="40px" height="40px"
								alt="" />
							<span style="font-weight: bold;margin-left: 1rem;"
								v-if="item.product">{{item.product.title}}</span>
							<span style="font-weight: bold;margin-left: 1rem;"
								v-if="item.productCustom">{{item.productCustom.title}}</span>
						</div>
					</div>
					<div v-show="list.length==0" class="nodata-box">
						<img src="../../assets/imgs/nodata.svg" class="nodata-img">
					</div>
				</div>
				<pagination v-if="activeIndex!=0" :page="params.page" :page-size="params.perPage" :total="nowtotal||0"
					:on-page-change="onPage" :pageSizeList="[]" class="pagi page-content" />
				<el-dialog :visible.sync="previewVisible"> <img width="100%" :src="dialogImageUrl" alt="">
				</el-dialog>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	let backup = {}
	import Header from '/src/components/header.vue'
	import Footer from '/src/components/footer.vue'
	import Pagination from '@/components/pagination.vue';
	import {
		VueEditor
	} from 'vue2-editor'
	export default {
		data() {
			return {
				user: {},
				isMobile: false,
				type: 'add',
				id: '',
				data: null,
				activeIndex: 0,
				providerinfo: null,
				dialogVisible: false,
				list: [],
				active: 0,
				input: '',
				page: 1,
				perPage: 6,
				nowtotal: 0,
				formParams: {
					title: "",
					sub_title: "",
					brandId: null,
					description: "",
					categoryId: null,
					countryId: null,
					certification: '',
					properties: "",
					countryId: null,
					main_pics: []
				},
				params: {
					providerId: null,
					page: 1,
					perPage: 8
				},
				brands: [],
				countrys: [],
				categories: [],
				authentications: [],
				propertiesList: [],
				properties: {},
				showProperties: true,
				dialogImageUrl: '',
				previewVisible: false,
				fileList: [],
				showTabs: false
			}
		},
		props: {},
		computed: {
			isPay() {
				return this.user.vipId ? true : (this.providerinfo && this.providerinfo.isPay ? true : false);
			}
		},
		components: {
			Header,
			Footer,
			Pagination,
			VueEditor
		},
		filters: {},
		methods: {
			handleChange(value) {
				this.formParams.categoryId = value[value.length - 1]
				this.selectType();
			},
			async selectType() {
				let res4 = await this.$get('/gci/authentication', {
					categoryId: this.formParams.categoryId
				})
				this.authentications = res4.data
			},
			detail(item) {
				if (item.productCustom) {
					this.$router.push({
						name: 'demandDetails',
						query: {
							id: item.productCustomId
						}
					})
				} else {
					this.$router.push({
						name: 'productDetail',
						query: {
							id: item.pid
						}
					})
				}
			},
			addProduct() {
				this.fileList = [];
				this.dialogVisible = true
				for (let key in this.properties) {
					this.properties[key] = ''
				}
				this.formParams = backup;
				this.type = "add"
			},
			update(item) {
				this.formParams = item;
				this.fileList = item.main_pics.map((v, i) => {
					return {
						url: v,
						name: `${i}.png`
					}
				});
				this.dialogVisible = true;
				this.type = "update"
			},
			remove(file, fileList) {
				this.fileList = fileList.map(v => {
					return {
						url: v.response ? v.response.data.url : v.url,
						name: v.name
					}
				})
			},
			upload(response, file, fileList) {
				this.fileList = fileList.map(v => {
					return {
						url: v.response ? v.response.data.url : v.url,
						name: v.name
					}
				})
			},
			handlePictureCardPreview(file, fileList) {
				this.dialogImageUrl = file.response.data.url;
				this.previewVisible = true;
			},
			async changeStatus(item) {
				let res = await this.$post(`/gci/product/${item.id}/edit`, {
					state: item.state ? false : true
				})
				this.$bus.$emit('message', {
					type: 2,
					msg: res.msg
				})
				this.getList();
			},
			async submit() {
				let array = []
				for (let key in this.properties) {
					if (this.properties[key]) array.push(this.properties[key])
				}
				this.formParams.properties = array.join(',')
				if (!this.fileList.length) return this.$bus.$emit('message', {
					type: 1,
					msg: 'main pics cannot be empty!'
				})
				this.formParams.main_pics = this.fileList.map(v => v.url).join(',')
				let res
				res = this.type == 'add' ? await this.$post('/gci/product/add', this.formParams) : await this.$post(
					`/gci/product/${this.formParams.id}/edit`, this.formParams)
				this.$bus.$emit('message', {
					type: 2,
					msg: res.msg
				})
				this.dialogVisible = false;
				this.getList()
			},
			handleImageAdded(file, Editor, cursorLocation, resetUploader) {
				// 引入包内自带的formdata
				const formData = new FormData();
				// 将前端传入formdata中数据名为file的数据追加到formdata,与上篇文章的图片上传相同
				formData.append("file", file);
				// 使用我们上篇文章定义好的图片上传接口,将formdata数据传到后台,并接收返回的数据到res
				this.request.post('/upload', formData).then(res => {
					if (res.status == 0) {
						this.$bus.$emit('message', {
							type: 2,
							msg: 'upload success'
						})
						// 找到返回数据中的图片链接
						let url = res.data.url;
						// 用vue-editor包自带的插入方法:在光标所在位置,插入一张图片,图片的地址是url
						Editor.insertEmbed(cursorLocation, "image", url);
						// 刷新(重置)编辑器
						resetUploader();
					}
				})
			},
			change(value, key) {
				this.$set(this.properties, key, value)
				this.showProperties = false;
				this.showProperties = true;
			},
			previous() {
				this.active -= 1;
			},
			next() {
				console.log(this.formParams);
				console.log(this.properties);
				if (!this.formParams.categoryId) return this.$bus.$emit('message', {
					type: 1,
					msg: 'Type cannot be empty!'
				})
				// if (!this.formParams.brandId) return this.$bus.$emit('message', {
				// 	type: 1,
				// 	msg: 'Brand cannot be empty!'
				// })
				if (!this.formParams.countryId) return this.$bus.$emit('message', {
					type: 1,
					msg: 'origin cannot be empty!'
				})
				if (!this.formParams.title) return this.$bus.$emit('message', {
					type: 1,
					msg: 'title cannot be empty!'
				})
				if (!this.formParams.sub_title) return this.$bus.$emit('message', {
					type: 1,
					msg: 'sub_title cannot be empty!'
				})
				this.active += 1;
				if (this.active == 1) this.getProperties()
				window.scrollTo(0, 0);
			},
			async getList() {
				if (this.activeIndex == 1) {
					let {
						data
					} = await this.$get('/gci/products', this.params)
					this.list = data.items;
					this.nowtotal = data.total
					this.getOptions()
				} else if (this.activeIndex == 2) {
					let {
						data
					} = await this.$get('/gci/product/custom/offers', this.params)
					this.list = data.items;
					this.nowtotal = data.total
				} else if (this.activeIndex == 3) {
					let {
						data
					} = await this.$get('/gci/product/enquires', this.params)
					this.list = data.items;
					this.nowtotal = data.total
				}
			},
			changeList(index) {
				this.params.page = 1;
				this.activeIndex = index;
				this.getList();
			},
			async getOptions() {
				let res1 = await this.$get('/brands')
				this.brands = res1.data.items
				let res2 = await this.$get('/gci/country/list')
				this.countrys = res2.data.items
				let res3 = await this.$get('/categories')
				this.categories = res3.data.items
				let res4 = await this.$get('/gci/authentication')
				this.authentications = res4.data
			},
			async getProperties() {
				let res = await this.$get(`/category/properties`, {
					categoryId: this.formParams.categoryId
				})
				this.propertiesList = res.data.properties
				if (this.type == 'update') {
					this.formParams.properties.forEach(v2 => this.properties[v2.label] = v2.id)
				} else {
					this.propertiesList.forEach(v => this.properties[v.label] = "")
				}
			},
			onPage(pageNow) {
				this.params.page = pageNow;
				window.scrollTo(0, 0);
				this.getList()
			},
			largeimg(imgs, index) {
				this.$bus.$emit('largeimg', {
					show: true,
					imgs: imgs,
					index: index
				})
			},
			tosupplierlist() {
				this.$router.push({
					name: 'supplierlist'
				})
			},
			changefollow(item) {
				let params = {
					providerId: item.id
				}
				this.request({
					method: 'post',
					url: '/gci/user/provider/follow',
					data: params
				}).then(res => {
					if (res.status == 0) {
						this.$bus.$emit('message', {
							type: 2,
							msg: res.msg
						})
						this.getdata()
					} else {
						this.$bus.$emit('message', {
							type: 3,
							msg: res.msg
						})
					}
				}).catch(error => {
					console.error(error.response)
				})
			},
			getdata() {
				this.request({
					method: 'get',
					url: '/gci/user/provider/get?id=' + this.id,
				}).then(res => {
					this.data = res.data
					this.$bus.$emit('loading', false)

					this.$nextTick(() => {
						const el = this.$refs.el
						el.addEventListener('contextmenu', this.handleRightClick)
					})
				}).catch(error => {
					console.error(error.response)
				})
			},
			toaddr() {
				window.open(this.data.website)
			},
			handleRightClick(event) {
				event.preventDefault()
			},
			getuserinfo() {
				this.request({
					method: 'get',
					url: '/gci/user/info',
				}).then(res => {
					this.user = res.data
					this.showTabs = (this.id == res.data.provider.id && res.data.provider.status == 1) ? true :
						false
					if (res.data.uid == this.data.uid) {
						this.providerinfo = res.data.provider
						this.params.perPage=7
					}
				}).catch(error => {
					console.error(error.response)
				})
			},
			toEdit() {
				if (this.providerinfo.status == 3) {
					this.$bus.$emit('message', {
						type: 1,
						msg: 'please reviewing'
					})
				}
				if (this.providerinfo.status == 1 || this.providerinfo.status == 2) {
					this.$router.push({
						name: 'applysupplier'
					})
					// location.reload()
				}
			},
			reviewing() {
				this.$bus.$emit('message', {
					type: 1,
					msg: 'Your service provider information has been submitted and is waiting for approval.'
				})
			},
			locking() {
				this.$bus.$emit('message', {
					type: 1,
					msg: 'The homepage is frozen, please contact customer service to inquire about the situation.'
				})
			}
		},
		created() {
			this.$bus.$emit('loading', true)
		},
		mounted() {
			localStorage.getItem('isMobile') == 'null' ? this.isMobile = false : this.isMobile = true
			backup = JSON.parse(JSON.stringify(this.formParams))
			this.id = this.$route.query.id
			this.params.providerId = this.$route.query.id;
			this.getdata()
			if (localStorage.getItem('token')) {
				this.getuserinfo()
			}
		}
	}
</script>

<style scoped lang="scss">
	div {
		box-sizing: border-box;
	}

	.el-button:hover {
		color: black !important;
		background-color: #23ebe2;
	}

	.label {
		font-weight: bold;
		margin: 1rem 0;
	}

	.require {
		font-weight: bold;
		font-size: 25px;
		transform: translateY(5px);
		color: crimson;
		margin-right: 5px;
	}

	.subTitle {
		margin-top: 0.5rem;
	}

	.user-name {
		font-size: 20px;
		font-weight: bold;
	}

	.avatar {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		margin-right: 0.5rem;
	}

	.items {
		overflow: hidden;
		cursor: pointer;
		padding: 1rem;
		margin-top: 1rem;
		border-radius: 0.5rem;
		border: 1px solid #e8e8e8;
	}

	.label {
		font-weight: bold;
		margin: 1rem 0;
	}

	.main-box {
		display: flex;
		margin-bottom: 2rem;
	}

	.main-img {
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		// border: 0.05rem solid rgba(0, 0, 0, 0.1);
	}

	.supplier-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		margin: 0.5rem 0;
		border-radius: 0.5rem;
	}

	.top-bg {
		background-position: center top;
		background-size: cover;
		background-repeat: no-repeat;
		width: calc(100vw + 4rem);
		height: 24rem;
		display: flex;
		align-items: center;
		justify-content: center;
		filter: blur(15px) brightness(1.2);
		position: absolute;
		left: 0;
		top: 0;
		z-index: 0;
	}

	.title-box {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		height: auto;
		position: relative;
		padding-bottom: 2rem;
	}

	.line-title {
		cursor: pointer;
	}

	.line-title:hover {
		color: #62e0c9 !important;
	}

	.r-title {
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;

		.r-title-bg {
			width: 13rem;
			position: absolute;
			left: -0.5rem;
			top: -2rem
		}
	}

	.title {
		font-size: 1.6rem;
		font-weight: bold;
	}

	.dectitle {
		font-size: 1rem;
		font-weight: 500;
	}

	.title-img {
		min-width: 9rem;
		height: 9rem;
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		margin-right: 2rem;
		background-color: #fff;
	}

	@media (max-width:767px) {
		/deep/ .el-step__title {
			line-height: 26px;
		}

		.label {
			margin: 0.3rem 0 !important;
		}

		.addproduct {}

		.tabs {
			overflow-x: scroll;
		}

		.title {
			font-size: 1.2rem;
		}

		.dectitle {
			font-size: 0.7rem;
		}

		.title-img {
			min-width: 5rem;
			height: 5rem;
			margin-right: 1rem;
			margin-left: 1rem;
			margin-top: 0.5rem;
		}
	}
</style>